import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Button, Card, CardContent } from '@mui/material';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { ViewTitle } from '../../components/ViewTitle';
import { BackButton } from '../../components/Button';

import * as actions from '../../redux/actions';
import { JobForm } from '../../components/Forms';
import Loading from '../../components/Loading';
import { Error } from '../../components/Error';
import { CONFIG } from '../../utils/constants';

const defaultValue = { licence_number: '', type: '' };

function CreateJob({ title, subtitle }) {
  const dispatch = useDispatch();
  const customer = useSelector((state) => state.customer);
  const zonePrice = useSelector((state) => state.zonePrice);
  const history = useHistory();
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
  } = useForm();

  useEffect(() => {
    // Avoid made conflict when create job and zone price
    dispatch(actions.zonePriceAll({ page: 1, size: CONFIG.infiniteLimit }));
    dispatch(actions.customerAll({ page: 1, size: CONFIG.infiniteLimit }));
    return () => {};
  }, []);

  const onSubmitJob = async (data) => {
    try {
      console.log('Job Payload', data);
      await dispatch(actions.jobCreate(data));
      reset(defaultValue);
      alert('สำเร็จ');
      history.goBack();
    } catch (error) {
      console.error(error);
    }
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const renderBackButton = () => (
    <div>
      <BackButton />
    </div>
  );

  const renderForm = () => (
    <div className="my-2">
      <Card>
        <CardContent>
          <div className=" font-semibold text-xl">สร้างงาน </div>
          <div className="my-2 ">
            <form onSubmit={handleSubmit(onSubmitJob)}>
              <JobForm
                control={control}
                customer={customer}
                errors={errors}
                watch={watch}
                zonePrice={zonePrice}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </div>
        </CardContent>
      </Card>
    </div>
  );

  if (zonePrice.isLoading) {
    return <Loading />;
  }

  if (!zonePrice.isLoading && zonePrice.isCompleted) {
    return (
      <div>
        {renderTitle()}
        {renderBackButton()}
        {renderForm()}
      </div>
    );
  }
  return <Error />;
}

CreateJob.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

CreateJob.defaultProps = {
  title: '',
  subtitle: '',
};

export default CreateJob;
